module.exports = __webpack_public_path__ + "media/film-noir-typing-on-an-old-typewriter_ekvx-cing_1080__D.e7dd46e4.mp4";